import React from 'react';
import Section from '../Section';

const Gallery: React.FC = () => {
  return (
      <Section id="gallery" additionalStyles={{ backgroundColor: '#222222' }}>
        <h2>Gallery</h2>
        <p>Check out our latest builds and repairs. Follow @rust_reduction on Instagram for more!</p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
          {/* Add more images/videos as needed; replace paths with your files */}
          <img src="/images/gallery1.jpg" alt="Rust repair on '62 Biscayne" style={{ width: '100%', borderRadius: '8px' }} />
          <img src="/images/gallery2.jpg" alt="Turbo LS-swapped S10" style={{ width: '100%', borderRadius: '8px' }} />
          <img src="/images/gallery3.jpg" alt="Dodge Dart muscle build" style={{ width: '100%', borderRadius: '8px' }} />
          {/* For videos: <video src="/videos/build.mp4" controls style={{ width: '100%' }} /> */}
        </div>
      </Section>
  );
};

export default Gallery;